import React from 'react';

import {Container, Heading, Image, Pane, SubHeading, Text, InfoContainer} from './styles/about';

export default function About({children, ...restProps}){
    return <Container {...restProps}>{children}</Container>
}

About.SubHeading = function AboutSubHeaing({children, ...restProps}){
    return <SubHeading {...restProps}>{children}</SubHeading>
}

About.Heading = function AboutHeading({children, ...restProps}){
    return <Heading {...restProps}>{children}</Heading>
}

About.Text = function AboutText({children, ...restProps}){
    return <Text {...restProps}>{children}</Text>
}

About.Image = function AboutImage({children, ...restProps}){
    return <Image {...restProps} />
}

About.Pane = function AboutPane({children, ...restProps}){
    return <Pane {...restProps}>{children}</Pane>
}

About.InfoContainer = function AboutInfoContainer({children, ...restProps}){
    return <InfoContainer {...restProps}>{children}</InfoContainer>
}